/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Car = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 40 19" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <defs><path id="a" d="M1116.054 8802.6c-2.945-2.4.604-5.074 8.008-6.248 7.604-1.206 17.27-.495 22.094 1.673l.045.022.402-.565 1.992.149a.26.26 0 0 1-.041-.02c-5.702-2.504-16.943-3.32-25.8-1.936-8.813 1.38-13.097 4.578-9.443 7.453l1.977.167z" /><path id="b" d="M1147.645 8798.855c3.136 2.209.736 4.912-6.576 6.292-8.288 1.564-18.944.723-23.735-1.746l-.748.697-2.025-.173c5.583 2.99 18.347 4.022 28.245 2.12 8.974-1.722 11.515-5.115 7.06-7.756l-1.744-.132z" /><path id="c" d="M1143.207 8793.225c-.204.358-.686.561-1.226.673.519.747.043.85.07.909.098.205.33-.21.305.61l-.08 2.82v1.856c0 1.045-.37.898-1.467.898h-.735c-.783 0-1.158-.058-1.52-.951a7.78 7.78 0 0 0-.074-.184h-12.34c-.022.058-.047.12-.074.185-.363.893-.738.95-1.521.95h-.735c-1.1 0-1.47.147-1.47-.898v-1.898l-.079-2.78c-.015-.549.084-.092.286-.568.032-.07-.438-.184.09-.947-.63-.131-1.04-.358-1.218-.675a.833.833 0 0 1 .018-.843c.045-.088.62-1.1 2.496-1.1.053.001.268.013.531.051 1.929-2.66 2.03-2.71 2.182-2.787.282-.144.575-.276 1.255-.396.723-.121 4.35-.137 4.396-.137.045 0 3.694.015 4.407.136.686.119.974.249 1.282.404.147.074.243.121 2.17 2.782.263-.04.476-.05.51-.052h.001c1.828 0 2.43.929 2.527 1.106.156.274.16.578.013.836zm-16.218 3.764s-.1-1.69-.815-2.185c0 0-.935-.79-1.25-.803-.27-.01-.634.048-.772.536 0 0-.21.712-.133 1.474 0 0 .048.344.467.484.419.139 1.628.406 2.503.494zm8.993.082c-.088-.002-.984-.062-3.652-.066-2.668.004-3.56.064-3.651.066-.635.019-.215.82-.215.82 1.467.111 2.577.122 3.866.122 1.291 0 2.402-.01 3.87-.121 0 0 .42-.802-.218-.82zm2.15-4.083s.274 0 .146-.313c0 0-.898-1.853-1.612-2.685h-8.706c-.712.832-1.61 2.685-1.61 2.685-.128.313.147.313.147.313h11.634zm1.922 2.013c-.15-.484-.552-.541-.852-.531-.348.012-1.38.794-1.38.794-.79.49-.9 2.162-.9 2.162.966-.087 2.3-.352 2.763-.49.464-.137.517-.476.517-.476.084-.754-.148-1.459-.148-1.459z" /></defs><use href="#a" opacity=".5" transform="translate(-1112 -8788)" /><use href="#b" transform="translate(-1112 -8788)" /><use href="#c" transform="translate(-1112 -8788)" />
      </g>
    </svg>
  </span>
);

Car.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Car.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Car;
